module.exports = __webpack_public_path__ + "img/Roxxannia Wang.cc9eff90.jpg";